/**
 * 变量字段数据类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

import {I18nUtil} from "../../../i18n/i18n-service";

/**
 * 字段数据类型
 */
enum GSPVmVarDataType {
    /**
     * 文本
     */
    String = 'String',

    /**
     * 备注
     */
    Text = 'Text',

    /**
     * 整数
     */
    Integer = 'Integer',

    /**
     * 浮点数
     */
    Decimal = 'Decimal',

    /**
     * 布尔型
     */
    Boolean = 'Boolean',

    /**
     * 日期型
     */
    Date = 'Date',

    /**
     * 日期时间型
     */
    DateTime = 'DateTime',

    /**
     * 二进制
     */
    Binary = 'Binary',
}

export { GSPVmVarDataType };


export const GSPVmVarDataTypes:
    Array<{
        index: number, text: string, value: GSPVmVarDataType | string,
        canChangeLength: boolean, canChangePresicion: boolean, length: number, precision: number
    }> = [
        {
            index: 0, text: I18nUtil.instant("String"), value: GSPVmVarDataType.String, canChangeLength: true,
            canChangePresicion: false, length: 36, precision: 0
        },
        {
            index: 1, text: I18nUtil.instant("Text"), value: GSPVmVarDataType.Text, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 2, text: I18nUtil.instant("Integer"), value: GSPVmVarDataType.Integer, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 3, text: I18nUtil.instant("Decimal"), value: GSPVmVarDataType.Decimal, canChangeLength: true,
            canChangePresicion: true, length: 18, precision: 2
        },
        {
            index: 4, text: I18nUtil.instant("Boolean"), value: GSPVmVarDataType.Boolean, canChangeLength: false,
            canChangePresicion: false, length: 1, precision: 0
        },
        {
            index: 5, text: I18nUtil.instant("Date"), value: GSPVmVarDataType.Date, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 6, text: I18nUtil.instant("DateTime"), value: GSPVmVarDataType.DateTime, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 7, text: I18nUtil.instant("Binary"), value: GSPVmVarDataType.Binary, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        }
        // , {
        //     index: 8, text: '业务字段', value: 'UnifiedDataType', canChangeLength: false,
        //     canChangePresicion: false, length: 36, precision: 0
        // }
    ];

export class GetVariableDataTypesUtil {
    static GSPElementDataTypesWithouUdt(): Array<{
        index: number, text: string, value: GSPVmVarDataType | string,
        canChangeLength: boolean, canChangePresicion: boolean, length: number, precision: number
    }> {
        let types = new Array<any>();
        Object.assign(types, GSPVmVarDataTypes);
        types = types.slice(0, 8);
        return types;
    }
}



